export const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const apiFile = (path) => `${API_BASE}/api/files/${path}`;

export async function fetchAds() {
  try {
    const res = await fetch(`${API_BASE}/api/ads`);
    if (!res.ok) return [];
    const list = await res.json();
    return list.map((a) => ({
      id: a.id,
      title: a.title || "Studio ad",
      img: apiFile(a.storage_path),
    }));
  } catch {
    return [];
  }
}

let casesPromise = null;

export function fetchCaseOverrides() {
  if (!casesPromise) {
    casesPromise = fetch(`${API_BASE}/api/cases`)
      .then((r) => (r.ok ? r.json() : {}))
      .catch(() => ({}));
  }
  return casesPromise;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return "Something went wrong. Please try again.";
}

export async function adminFetch(url, opts = {}) {
  const res = await fetch(`${API_BASE}${url}`, { ...opts, credentials: "include" });
  if (res.status === 401 && !opts._retried) {
    const rf = await fetch(`${API_BASE}/api/admin/refresh`, { method: "POST", credentials: "include" });
    if (rf.ok) return adminFetch(url, { ...opts, _retried: true });
  }
  return res;
}